var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "b-modal",
    {
      ref: "modalAjoutProduits",
      attrs: {
        size: "xxl",
        "hide-footer": "",
        title:
          "Commande : " +
          _vm.commande.nom +
          " (Total actuel : " +
          _vm.commande.total +
          " € - Total après modification : " +
          _vm.totalPCB() +
          ")",
        "ok-title": "Valider",
        "cancel-title": "Annuler",
        "no-close-on-backdrop": ""
      },
      on: { ok: _vm.validerAjout }
    },
    [
      _c("template", { slot: "default" }, [
        _c(
          "div",
          { staticClass: "container-fluid flex-center-space-between" },
          [
            _c("Mercuriales", {
              ref: "mercuriales",
              staticClass: "pr-1 pl-0",
              attrs: {
                startFilters: _vm.filters,
                fournExclus: _vm.idsFournisseursVerrouilles || [],
                lectureSeule: true
              },
              on: {
                "clic-produit": _vm.ajouterProduit,
                "clic-tarif": _vm.ajouterProduit,
                "filter-changed": _vm.filterChanged
              }
            }),
            _c("div", { staticClass: "w-25 pl-1" }, [
              _c(
                "div",
                { staticClass: "card", staticStyle: { height: "210px" } },
                [
                  _c(
                    "div",
                    { staticClass: "card-header flex-start-space-between" },
                    [
                      _vm._v(
                        " " +
                          _vm._s(
                            _vm.produit.dAgap ||
                              "Description produit sélectionné"
                          ) +
                          " "
                      ),
                      _vm.produit.pId
                        ? _c(
                            "span",
                            {
                              attrs: { title: "Modifier favori" },
                              on: {
                                click: function($event) {
                                  return _vm.modifierFavori($event)
                                }
                              }
                            },
                            [
                              _c("i", {
                                staticClass: "fa-star cursor-pointer",
                                class: _vm.produit.estFavori
                                  ? "fas text-warning"
                                  : "far"
                              })
                            ]
                          )
                        : _vm._e()
                    ]
                  ),
                  _vm.produit.foId
                    ? _c("div", { staticClass: "card-body" }, [
                        _c(
                          "div",
                          { staticClass: "flex-center-space-between" },
                          [
                            _c("b", [_vm._v(_vm._s(_vm.produit.fournisseur))]),
                            _vm.produit.foId && _vm.produit.Ref
                              ? _c("BoutonFicheTechnique", {
                                  attrs: {
                                    size: "sm",
                                    fournisseurId: _vm.produit.foId,
                                    reference: _vm.produit.Ref
                                  }
                                })
                              : _vm._e()
                          ],
                          1
                        ),
                        _c("div", [
                          _vm._v(_vm._s(_vm.produit.dFou || _vm.produit.dAgap))
                        ]),
                        _c("div", [
                          _vm.produit.Ref || _vm.produit.marque
                            ? _c("span", [_vm._v("(")])
                            : _vm._e(),
                          _vm._v(_vm._s(_vm.produit.Ref)),
                          _vm.produit.Ref && _vm.produit.marque
                            ? _c("span", [_vm._v(" - ")])
                            : _vm._e(),
                          _vm._v(_vm._s(_vm.produit.marque)),
                          _vm.produit.Ref || _vm.produit.marque
                            ? _c("span", [_vm._v(")")])
                            : _vm._e()
                        ]),
                        _c("div", [
                          _c("b", [
                            _vm._v(
                              _vm._s(_vm.produit.pua) +
                                " / " +
                                _vm._s(_vm.produit.uc)
                            )
                          ])
                        ]),
                        _c("div", [
                          _vm._v(
                            "Montant total d'un lot : " +
                              _vm._s(_vm.produit.plot)
                          )
                        ]),
                        _c(
                          "span",
                          { staticClass: "flex-center-space-between" },
                          [
                            _c("div", [
                              _c(
                                "b",
                                {
                                  class: [
                                    {
                                      "text-warning":
                                        _vm.modulo(
                                          _vm.produit.qDem,
                                          _vm.produit.pcb
                                        ) !== 0
                                    }
                                  ]
                                },
                                [
                                  _vm._v(
                                    "Vendu par " +
                                      _vm._s(_vm.produit.pcb) +
                                      " " +
                                      _vm._s(_vm.produit.uc)
                                  )
                                ]
                              )
                            ])
                          ]
                        )
                      ])
                    : _vm.produit.pId
                    ? _c("div", { staticClass: "card-body" }, [
                        _vm._v(
                          _vm._s(_vm.produit.nbFournisseurs) +
                            " prix disponibles"
                        )
                      ])
                    : _c("div", { staticClass: "card-body" }, [
                        _vm._v("Veuillez sélectionner le(s) produit(s)")
                      ])
                ]
              ),
              _c(
                "div",
                { staticClass: "card table-scroll height-responsive-panier" },
                [
                  _c(
                    "div",
                    { staticClass: "card-header flex-center-space-between" },
                    [
                      _c("span", [_vm._v("Produits sélectionnés")]),
                      _c("span", [_vm._v(_vm._s(_vm.totalPCB()))])
                    ]
                  ),
                  _c(
                    "table",
                    {
                      staticClass:
                        "table table-bordered, table-sm table-header-secondary"
                    },
                    [
                      _c("colgroup", [
                        _c("col"),
                        _c("col", { staticStyle: { width: "100px" } })
                      ]),
                      _c("thead", [
                        _c("th", [_vm._v("Désignation")]),
                        _c("th", [_vm._v("Qté.")])
                      ])
                    ]
                  ),
                  _c("div", { staticClass: "table-body" }, [
                    _c("table", { staticClass: "table table-sm" }, [
                      _c("colgroup", [
                        _c("col"),
                        _c("col", { staticStyle: { width: "95px" } })
                      ]),
                      _c(
                        "tbody",
                        _vm._l(_vm.produits, function(prod, iProd) {
                          return _c(
                            "tr",
                            {
                              key: iProd,
                              class: [
                                {
                                  "ligne-selectionnee":
                                    prod.pId === _vm.produit.pId
                                }
                              ],
                              on: {
                                click: function($event) {
                                  return _vm.selectionnerProduit(prod, true)
                                }
                              }
                            },
                            [
                              prod.famille
                                ? [
                                    _c(
                                      "td",
                                      {
                                        staticClass: "table-header-tertiary",
                                        attrs: { colspan: "2" }
                                      },
                                      [_vm._v(_vm._s(prod.famille))]
                                    )
                                  ]
                                : [
                                    _c("td", { attrs: { title: prod.dFou } }, [
                                      _c(
                                        "label",
                                        {
                                          attrs: { for: "produit" + prod.pId }
                                        },
                                        [
                                          _vm._v(
                                            _vm._s(prod.dFou || prod.dAgap)
                                          )
                                        ]
                                      )
                                    ]),
                                    _c(
                                      "td",
                                      [
                                        _c("InputNumber", {
                                          staticStyle: { width: "45px" },
                                          attrs: {
                                            id: "produit" + prod.pId,
                                            typeFiltre: "quantite",
                                            zeroSiVide: "1",
                                            "data-pid": prod.pId,
                                            "data-tid": prod.tId
                                          },
                                          on: {
                                            move: function($event) {
                                              return _vm.deplacerSelectionProduit(
                                                $event
                                              )
                                            },
                                            click: function($event) {
                                              return _vm.selectionnerProduit(
                                                prod,
                                                true
                                              )
                                            }
                                          },
                                          model: {
                                            value: prod.qDem,
                                            callback: function($$v) {
                                              _vm.$set(prod, "qDem", $$v)
                                            },
                                            expression: "prod.qDem"
                                          }
                                        }),
                                        _vm._v(
                                          " " +
                                            _vm._s(_vm.abregerTexte(prod.uc, 7))
                                        )
                                      ],
                                      1
                                    )
                                  ]
                            ],
                            2
                          )
                        }),
                        0
                      )
                    ])
                  ])
                ]
              ),
              _c(
                "div",
                { staticClass: "actions flex-end" },
                [
                  _c(
                    "b-button",
                    {
                      staticClass: "btn btn-danger",
                      staticStyle: { "margin-right": "10px" },
                      on: { click: _vm.hide }
                    },
                    [_vm._v("Annuler")]
                  ),
                  _c(
                    "b-button",
                    {
                      staticClass: "btn btn-primary",
                      on: { click: _vm.validerAjout }
                    },
                    [_vm._v("Valider")]
                  )
                ],
                1
              )
            ])
          ],
          1
        )
      ])
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }